import { useState } from 'react'
import api from '../utils/api'

const S = {
  page: { minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: "'Inter', sans-serif" },
  card: { width: '100%', maxWidth: '560px', background: '#111', border: '1px solid #222', borderRadius: '8px', padding: '2.5rem' },
  title: { color: '#e0e0e0', fontSize: '1.3rem', fontWeight: 600, marginBottom: '0.4rem', fontFamily: "'Merriweather', serif" },
  subtitle: { color: '#bbb', fontSize: '0.88rem', marginBottom: '2rem', lineHeight: '1.6' },
  label: { display: 'block', color: '#bbb', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.35rem' },
  input: { width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: '4px', color: '#e0e0e0', padding: '0.65rem 0.8rem', fontSize: '0.95rem', boxSizing: 'border-box', marginBottom: '1.2rem', outline: 'none' },
  textarea: { width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: '4px', color: '#e0e0e0', padding: '0.65rem 0.8rem', fontSize: '0.95rem', boxSizing: 'border-box', marginBottom: '1.2rem', outline: 'none', resize: 'vertical', minHeight: '100px' },
  btn: { width: '100%', background: '#8B1A1A', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.75rem', fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer', letterSpacing: '0.04em', marginTop: '0.25rem' },
  btnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  success: { color: '#4caf50', fontSize: '0.95rem', textAlign: 'center', marginTop: '1rem', lineHeight: '1.6' },
  error: { color: '#e74c3c', fontSize: '0.85rem', marginBottom: '1rem' },
}

export default function AccessRequest() {
  const [form, setForm] = useState({ name: '', email: '', affiliation: '', reason: '' })
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const valid = form.name.trim() && form.email.includes('@') && form.reason.trim().length > 10

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }))

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!valid) return
    setStatus('submitting')
    setError('')
    try {
      await api.post('/auth/access-request', form)
      setStatus('success')
    } catch (err) {
      setError(err.response?.data?.error || 'Submission failed. Please try again.')
      setStatus('idle')
    }
  }

  if (status === 'success') {
    return (
      <div style={S.page}>
        <div style={S.card}>
          <div style={S.title}>Request Received</div>
          <div style={{ ...S.success, marginTop: '1.2rem' }}>
            <p>Your access request has been submitted.</p>
            <p style={{ marginTop: '0.75rem', color: '#bbb', fontSize: '0.88rem' }}>
              If approved, you will receive an invitation link by email within a few business days.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.title}>Request Research Access</div>
        <div style={S.subtitle}>
          This database is restricted to researchers, journalists, policy professionals, and conservation advocates with a relevant interest in Atlantic menhaden management. Access is granted by invitation only.
        </div>

        {error && <div style={S.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={S.label}>Full Name *</label>
          <input style={S.input} type="text" value={form.name} onChange={set('name')} required autoComplete="name" />

          <label style={S.label}>Email Address *</label>
          <input style={S.input} type="email" value={form.email} onChange={set('email')} required autoComplete="email" />

          <label style={S.label}>Affiliation / Organization</label>
          <input style={S.input} type="text" value={form.affiliation} onChange={set('affiliation')} placeholder="University, agency, organization, or independent" />

          <label style={S.label}>Why are you requesting access? *</label>
          <textarea style={S.textarea} value={form.reason} onChange={set('reason')} required placeholder="Please describe your research interest, professional role, or intended use..." />

          <button
            type="submit"
            style={{ ...S.btn, ...((!valid || status === 'submitting') ? S.btnDisabled : {}) }}
            disabled={!valid || status === 'submitting'}
          >
            {status === 'submitting' ? 'Submitting...' : 'Submit Request'}
          </button>
        </form>
      </div>
    </div>
  )
}
